import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols';
import _indexOfInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/index-of';
import _Object$keys from '@babel/runtime-corejs3/core-js-stable/object/keys';
import _Symbol$for from '@babel/runtime-corejs3/core-js-stable/symbol/for';
import { jsx } from 'react/jsx-runtime.js';
import { memo, useEffect } from 'react';
import '../../../../dnd-core/dist/esm/4d2b8470e87c4f0b950c6bc8b4f35eae368ccca9e5a2a8d413ca44b2254cf1ac.cfe-internal.js';
import { DndContext } from './801e8f0253a7757d69bdfd073e114896d25e080494d1b1d2d7f88c11b86b3d19.cfe-internal.js';
import { createDragDropManager } from '../../../../dnd-core/dist/esm/a743254b655f98881ddaf34685cd1478abfe139c9c0fad7a431ad419706bcfc6.cfe-internal.js';

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (_Object$getOwnPropertySymbols) {
    var sourceSymbolKeys = _Object$getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (_indexOfInstanceProperty(excluded).call(excluded, key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = _Object$keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (_indexOfInstanceProperty(excluded).call(excluded, key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
var refCount = 0;
var INSTANCE_SYM = _Symbol$for('__REACT_DND_CONTEXT_INSTANCE__');
var DndProvider = /*#__PURE__*/memo(function DndProvider(_param) {
  var children = _param.children,
    props = _objectWithoutProperties(_param, ["children"]);
  var _getDndContextValue = getDndContextValue(props),
    _getDndContextValue2 = _slicedToArray(_getDndContextValue, 2),
    manager = _getDndContextValue2[0],
    isGlobalInstance = _getDndContextValue2[1];
  /**
  * If the global context was used to store the DND context
  * then where theres no more references to it we should
  * clean it up to avoid memory leaks
  */
  useEffect(function () {
    if (isGlobalInstance) {
      var context = getGlobalContext();
      ++refCount;
      return function () {
        if (--refCount === 0) {
          context[INSTANCE_SYM] = null;
        }
      };
    }
    return;
  }, []);
  return /*#__PURE__*/jsx(DndContext.Provider, {
    value: manager,
    children: children
  });
});
function getDndContextValue(props) {
  if ('manager' in props) {
    var _manager = {
      dragDropManager: props.manager
    };
    return [_manager, false];
  }
  var manager = createSingletonDndContext(props.backend, props.context, props.options, props.debugMode);
  var isGlobalInstance = !props.context;
  return [manager, isGlobalInstance];
}
function createSingletonDndContext(backend) {
  var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getGlobalContext();
  var options = arguments.length > 2 ? arguments[2] : undefined;
  var debugMode = arguments.length > 3 ? arguments[3] : undefined;
  var ctx = context;
  if (!ctx[INSTANCE_SYM]) {
    ctx[INSTANCE_SYM] = {
      dragDropManager: createDragDropManager(backend, context, options, debugMode)
    };
  }
  return ctx[INSTANCE_SYM];
}
function getGlobalContext() {
  return typeof global !== 'undefined' ? global : window;
}

export { DndProvider };
